var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _require = require('lodash'),
    get = _require.get,
    trim = _require.trim;

var WTError =
/*#__PURE__*/
function (_Error) {
  "use strict";

  _inherits(WTError, _Error);

  function WTError() {
    var _this;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, WTError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WTError).call(this, raw));

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this)), WTError);
    }

    _this.message = _this.enhanceErrorMessage(message, raw);
    _this.raw = raw;
    _this.timestamp = Date.now();
    return _this;
  }

  _createClass(WTError, [{
    key: "enhanceErrorMessage",
    value: function enhanceErrorMessage(originalMessage, error) {
      var responseMessage = get(error, 'response.data.message', '');
      var message = originalMessage ? originalMessage : this.defaultErrorMessage(get(error, 'response', ''));
      return trim("".concat(message, "\n").concat(responseMessage));
    }
  }, {
    key: "defaultErrorMessage",
    value: function defaultErrorMessage() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          status = _ref.status;

      if (status >= 200 && status <= 299) {
        return '';
      } else if (status >= 400 && status <= 499) {
        return "Response had a ".concat(status, " code, the server will not accept this request even if retried.");
      } else if (status >= 500 && status <= 504) {
        return "Response had a ".concat(status, " code, we could retry.");
      }

      return "Response had a ".concat(status, " code, no idea what to do with that.");
    }
  }]);

  return WTError;
}(_wrapNativeSuper(Error));

module.exports = WTError;